import CashPrepaymentDetail from 'components/productDetail/prepayment/cash';
import Header from 'modules/header/farm/main';
import {useLocation} from 'react-router-dom';
import useGetPostDetail from '../hooks/useGetPostDetail';
import CreditPrepayment from 'components/productDetail/prepayment/credit';
import {useState} from 'react';
import CustomBottomSheet from 'components/bottomSheet';
import ViolationModal from 'modules/violationModal';
import {ViolationReportDetailItems} from 'pages/wholesaler/productDetail/constants';

const PrepaymentDetailPage = () => {
  const [openViolationModal, setOpenViolationModal] = useState<boolean>(false);
  const location = useLocation();
  const {productDetail, isLoading} = useGetPostDetail(location.state.guid);
  const isFarm = location.pathname.includes('farm');
  return (
    <>
      {!isLoading && productDetail && (
        <>
          <Header title={productDetail.title} />
          {productDetail.financial_type === 'cash' && (
            <CashPrepaymentDetail
              post={productDetail}
              app="farmer"
              setOpenViolationModal={setOpenViolationModal}
            />
          )}
          {productDetail.financial_type === 'credit' && (
            <CreditPrepayment
              post={productDetail}
              app="farmer"
              setOpenViolationModal={setOpenViolationModal}
            />
          )}
        </>
      )}
      <CustomBottomSheet
        isOpen={openViolationModal}
        onDismiss={() => setOpenViolationModal(false)}
      >
        <ViolationModal
          open={openViolationModal}
          handleClose={() => setOpenViolationModal(false)}
          items={ViolationReportDetailItems}
          guid={location.state.guid}
          object_type="market"
          isFarm={isFarm}
        />
      </CustomBottomSheet>
    </>
  );
};

export default PrepaymentDetailPage;
